<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <v-select multiple @search="fetchOptions" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="fullname" :options="users" class="select-size-lg" :reduce="user => user" />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  created: async function () {
    await this.fetchInitialUsers()
    this.selected = this.initialSelections.map(user => user)
  },
  props: {
    initialSelections: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(String(email).toLowerCase())
    },
    async fetchOptions(search, loading) {
      if (search.length <= 3) {
        loading(false)
        return
      }

      loading(true)
      try {
        const response = await axios.get(`/admin/f/cm/getmembers?p=1&l=10&q=${search}`)
        const { users } = response.data
        this.users = users.filter(user => this.isValidEmail(user.email))
      } catch (error) {
        console.error('Search fetch error:', error)
      } finally {
        loading(false)
      }
    },

    async fetchInitialUsers() {
      try {
        if (this.initialSelections.length > 0) {
          const response = await axios.get(`/admin/f/cm/getmembers?ids=${this.initialSelections.join(',')}`)
          const { users } = response.data
          this.users = users.filter(user => this.isValidEmail(user.email || user.notificationEmail))
          
        } else {
          const response = await axios.get('/admin/f/cm/getmembers?p=1&l=10')
          const { users } = response.data
          this.users = users.filter(user => this.isValidEmail(user.email))
        }
      } catch (error) {
        console.error('Initial users fetch error:', error)
      }
    },
  },

  watch: {
    selected(newVal) {
      // Emit the selected IDs to parent
      this.$emit("selectionChanged", newVal)
    },
  },

  data() {
    return {
      users: [],
      selected: []
    }
  }
}
</script>